import {
    signInWithPhoneNumber,
    RecaptchaVerifier,
    PhoneAuthProvider,
    signInWithCredential,
    signOut,
    onAuthStateChanged
} from 'firebase/auth';
import { auth } from './config';

// Create reCAPTCHA verifier
export const createRecaptchaVerifier = (elementId) => {
    return new RecaptchaVerifier(auth, elementId, {
        size: 'invisible',
        callback: (response) => {
            console.log('reCAPTCHA solved');
        },
        'expired-callback': () => {
            console.log('reCAPTCHA expired');
        }
    });
};

// Send OTP to phone number
export const sendOTP = async (phoneNumber, recaptchaVerifier) => {
    try {
        const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, recaptchaVerifier);
        return confirmationResult;
    } catch (error) {
        console.error('Error sending OTP:', error);
        throw error;
    }
};

// Verify OTP
export const verifyOTP = async (confirmationResult, otp) => {
    try {
        const result = await confirmationResult.confirm(otp);
        return result.user;
    } catch (error) {
        console.error('Error verifying OTP:', error);
        throw error;
    }
};

// Sign out user
export const logout = async () => {
    try {
        await signOut(auth);
    } catch (error) {
        console.error('Error signing out:', error);
        throw error;
    }
};

// Listen to auth state changes
export const onAuthStateChange = (callback) => {
    return onAuthStateChanged(auth, callback);
};

// Get current user
export const getCurrentUser = () => {
    return auth.currentUser;
};
